import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CKEditor from "react-ckeditor-component";
import renderHTML from "react-render-html";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { get_static_page_details } from "../../../redux/actions/termsPolicyAndContactActions";
import loader from "../../../style/loader/loader.scss";

const history = createHashHistory();
class TermsAndCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Settings", "Manage Terms Contact And Policy"],
      msgType: "",
      alertMessage: "",
      show: "",
      termsAndCondition: "",
      privacyPolicy: "",
      contactUs: ""
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.props.get_static_page_details();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);

      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        {this.props.staticPageDetails &&
        this.props.staticPageDetails.termsAndCondition ? (
          <div className="container">
            {this.props.fetchingDetails ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div>
              <div className="row">
                {this.state.show &&
                  this.state.alertMessage !== "" &&
                  this.state.msgType && (
                    <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
              </div>
              <div className="panel" style={{ marginTop: "40px" }}>
                <header className="panel-heading">Terms and Conditions</header>
                {this.props.staticPageDetails &&
                this.props.staticPageDetails.termsAndCondition ? (
                  <div className="panel-body">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <Row>
                        <Col md={8} xs={12} mdOffset={2}>
                          <Row>
                            <Col md={12} xs={12}>
                              <div>
                                {renderHTML(
                                  this.props.staticPageDetails.termsAndCondition
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ) : (
                  <div className="panel" style={{ marginTop: "40px" }}>
                    <header className="panel-heading">Contact Us</header>
                    <div className="panel-body">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <Row>
                          <Col md={8} xs={12} mdOffset={2}>
                            <Row>
                              <Col md={12} xs={12}>
                                <div style={{ textAlign: "center" }}>
                                  Content is not available
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

TermsAndCondition.propTypes = {
  get_static_page_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  staticPageDetails: state.termsPolicyAndContactReducer.staticPageDetails,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  fetchingDetails: state.termsPolicyAndContactReducer.fetchingDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_static_page_details, clearAlert, renderAlert })
)(TermsAndCondition);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/TermsAndCondition.js